// src/App.js
import "./App.css";
import { useNavigate } from "react-router-dom";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { useSelector } from "react-redux"; // Import useSelector
import { externalConfig, internalConfig } from "./config"; // Adjust the import path
import Routes from "../src/routes/Routes";

function App() {
  const navigate = useNavigate();
  const { External } = useSelector((store) => store.config); // Get the authentication state
  // Determine the configuration based on the state
  const config = External ? internalConfig : externalConfig; // reversed
  const oktaAuth = new OktaAuth(config); // Create an instance of OktaAuth based on the current config

  // Correctly defining restoreOriginalUri callback
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
    >
      <Routes />
    </Security>
  );
}

export default App;
